// Constructable style helpers with caching + graceful fallback
const _cache = new Map();
const _sheetText = new WeakMap();
let SUPPORTS_CONSTRUCTABLE = typeof CSSStyleSheet !== 'undefined' && 'replaceSync' in CSSStyleSheet.prototype;
let SUPPORTS_ADOPTION = SUPPORTS_CONSTRUCTABLE && 'adoptedStyleSheets' in Document.prototype;

export function css(strings, ...values) {
	const text = String.raw({ raw: strings }, ...values);
	let sheet = _cache.get(text);
	if (sheet) return sheet;

	if (SUPPORTS_CONSTRUCTABLE) {
		try {
			sheet = new CSSStyleSheet();
			sheet.replaceSync(text);
			_sheetText.set(sheet, text);
		} catch (err) {
			SUPPORTS_CONSTRUCTABLE = false;
			SUPPORTS_ADOPTION = false;
			sheet = { text };
		}
	} else {
		sheet = { text };
	}

	_cache.set(text, sheet);
	return sheet;
}

const textForSheet = (sheet) => {
	if (!sheet) return '';
	if (sheet instanceof CSSStyleSheet) return _sheetText.get(sheet) ?? '';
	if (typeof sheet.text === 'string') return sheet.text;
	return '';
};

export function adoptStyles(shadowRoot, sheets = []) {
	const constructableSheets = SUPPORTS_ADOPTION ? sheets.filter((s) => s instanceof CSSStyleSheet) : [];
	if (constructableSheets.length && SUPPORTS_ADOPTION) {
		shadowRoot.adoptedStyleSheets = constructableSheets;
	}

	const needsInline = !SUPPORTS_ADOPTION || constructableSheets.length !== sheets.length;
	if (!needsInline) return;
	const inlineSheets = SUPPORTS_ADOPTION ? sheets.filter((s) => !(s instanceof CSSStyleSheet)) : sheets;
	inlineSheets.forEach((sheet) => {
		const style = document.createElement('style');
		style.textContent = textForSheet(sheet) || [..._cache.entries()].find(([k, v]) => v === sheet)?.[0] || '';
		shadowRoot.append(style);
	});
}
